"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStringAlphanumeric = void 0;
function isStringAlphanumeric(str) {
    return /^[a-zA-Z0-9]*$/i.test(str);
}
exports.isStringAlphanumeric = isStringAlphanumeric;
